import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Paper from '@material-ui/core/Paper'
import styles from '../../../styles'
import { OrganisationsTable }  from './OrganisationsTable'

export class OrganisationsPage extends React.Component {

    render() {
        return (
            <Paper className={this.props.classes.adminTablePaper} elevation={1}>
                <OrganisationsTable />
            </Paper>

        )
    }
}

OrganisationsPage = withStyles(styles, {withTheme: true})(OrganisationsPage)


// WEBPACK FOOTER //
// ./src/App/Admin/Organisations/OrganisationsPage.jsx